import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPositiveTick = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			y: .484863,
			width: 16,
			height: 16,
			rx: 8,
			fill: "#00CC6A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.48857 9.99602L4.99581 8.4606C4.768 8.22629 4.39866 8.22629 4.17085 8.4606C3.94305 8.69492 3.94305 9.07482 4.17085 9.30913L6.11529 11.3091C6.35784 11.5586 6.75631 11.54 6.9759 11.269L10.8648 6.46899C11.071 6.21442 11.0376 5.83608 10.7901 5.62395C10.5426 5.41181 10.1748 5.4462 9.96852 5.70077L6.48857 9.99602Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgPositiveTick);
export default ForwardRef;
